import * as standardTextsConfigurationDiffValues from "../../../configuration/standard-texts-configuration-diff.json";
import * as topProductConfigurationDiffValues from "../../../configuration/top-product-configuration-diff.json";
import CustomizedStandardTextsValuesConfigurationProvider from "./customized-values-configuration-provider";

export default new CustomizedStandardTextsValuesConfigurationProvider(
  standardTextsConfigurationDiffValues,
  topProductConfigurationDiffValues
);
